const translations = {
  "en": {
    "Get Real-Time Result": "Get Real-Time Result",
    "Results from data up to %{var0}": "Results from data up to %{var0}"
  },
  "zh-tw": {
    "Get Real-Time Result": "取得即時結果",
    "Results from data up to %{var0}": "資料截至 %{var0}"
  }
};

export default translations;
